// redux/BillingInvoice/Slice.ts

import { createSlice } from "@reduxjs/toolkit";
import { iBillingInvoiceState, REDUCER_NAME } from "./Types";
import { addBillingInvoice } from "./ThunkAction";

const initialState: iBillingInvoiceState = {
  isLoading: false,
  isSuccess: false,
  error: null,
};

const billingInvoiceSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetBillingInvoiceState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addBillingInvoice.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.error = null;
      })
      .addCase(addBillingInvoice.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.error = null;
      })
      .addCase(addBillingInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetBillingInvoiceState } = billingInvoiceSlice.actions;
export default billingInvoiceSlice.reducer;
